module.exports = __webpack_public_path__ + "img/vertical_5_1_8011.21fad8c9.png";